import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { LRStyle } from './LRStyleSet';

const { Text } = Typography;

export function LRSummaryItemBlock({ title, value }) {
	return (
		<Row style={{ paddingBottom: '20px' }}>
			<Col>
				<Row>
					<Col>
						<Text>{title}:</Text>
					</Col>
				</Row>
				<Row>
					<Col>
						<Text strong style={LRStyle.locationStyle}>
							{value}
						</Text>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}

LRSummaryItemBlock.propTypes = {
	title: PropTypes.string,
	value: PropTypes.string,
};
